import { useEffect, useState } from "react";
import PageContainer from "../components/admin/PageContainer";
import CollapseCard from "../components/admin/CollapseCard";
import Modal from "../components/admin/Modal";
import {
  createPages,
  deletePages,
  fetchAllPages,
  updatePages,
} from "../service/PageService";
import PagesForm from "../components/admin/PagesForm";
import PagesList from "../components/admin/PagesList";
import { useToast } from "../components/toast/ToastProvider";
import Main from "../components/admin/Main";
import { fetchDiscussionBySourceId, updateDiscussion } from "../service/DiscussionService";

const Pages = () => {
  const [pages, setPages] = useState([]);
  const [discussion, setDiscussion] = useState([]);
  const [selectedPage, setSelectedPage] = useState(null);
  const [showCommentsModal, setShowCommentsModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  const toast = useToast();
  const loadAds = async () => {
    try {
      setLoading(true);
      const res = await fetchAllPages();
      console.log("res", res);
      const pagesWithCount = await Promise.all(
        res.map(async (page) => {
          const discussions = await fetchDiscussionBySourceId(page.id, "page");
          const newCount = discussions.filter(
            (d) => d.status?.trim().toLowerCase() === "new"
          ).length;

          return { ...page, newCommentCount: newCount };
        })
      );


      setPages(pagesWithCount);
      console.log("Pages with comment count:", pagesWithCount);


    } catch (error) {
      toast("Error in fetch Page", "ERROR");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAds();
  }, []);

  const handleSave = async (adData) => {
    try {
      const formData = new FormData();
      formData.append("userId", adData.userId);
      formData.append("title", adData.title);
      formData.append("bannerImageUrl", adData.bannerImageUrl);
      formData.append("content", adData.content);

      if (selectedPage) {

        await updatePages(selectedPage.id, formData);
        toast("Page Updated", "SUCCESS");
      } else {
        await createPages(formData);
        toast("Page Added", "SUCCESS");
      }

      setShowModal(false);
      setSelectedPage(null);
      setViewMode(false);
      await loadAds();
    } catch (error) {
      toast("Error in save Page", "ERROR");
    }
  };

  const handleEdit = (ad) => {
    setSelectedPage(ad);
    setViewMode(false);
    setShowModal(true);
  };

  const handleView = (ad) => {
    setSelectedPage(ad);
    setViewMode(true);
    setShowModal(true);
  };

  const handleComments = async (id) => {
    try {
      const res = await fetchDiscussionBySourceId(id, "page");
      console.log("Fetched discussions:", res);


      const filtered = res.filter(
        (item) => item.source === "page" && item.source_id === id
      );

      if (filtered.length === 0) {
        toast("No discussions found for this page", "ERROR");
        setDiscussion([]);
        return;
      }

      console.log("Filtered discussions:", filtered);
      setDiscussion(filtered);
      setShowCommentsModal(true);
    } catch (err) {
      toast(err.message || "Failed to fetch discussions", "ERROR");
    }
  };
  const handleStatusChange = async (id, newStatus) => {
    try {
      const current = discussion.find((item) => item.id === id);
      if (!current) return;

      const formData = {
        source: current.source,
        sourceId: current.source_id,
        title: current.title,
        description: current.description,
        status: newStatus,
      };

      const res = await updateDiscussion(id, formData);
      console.log("Status updated:", res);

      setDiscussion((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, status: newStatus } : item
        )
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };


  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this ad?")) {
      try {
        setDeletingId(id);
        await deletePages(id);
        toast("Page Deleted", "SUCCESS");
        await loadAds();
      } catch (error) {
        toast("Error deleting Page", "ERROR");
      } finally {
        setDeletingId(null);
      }
    };
  }

  return (
    <Main>
      <PageContainer
        title="Pages"
        buttonText={loading ? "Loading..." : "ADD"}
        onButtonClick={() => {
          setSelectedPage(null);
          setViewMode(false);
          setShowModal(true);
        }}
      >
        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            setShowModal(false);
            setSelectedPage(null);
            setViewMode(false);
          }}
          headerText={
            viewMode ? "View Page" : selectedPage ? "Edit Page" : "Add Page"
          }
          centered
        >
          <PagesForm
            initialData={selectedPage}
            readOnly={viewMode}
            onSave={handleSave}
            loading={loading}
            setLoading={setLoading}
          />

          {viewMode && (
            <div className="d-flex justify-content-end mt-3">
              <button
                className="btn btn-success"
                onClick={() => {
                  setLoading(true);
                  setTimeout(() => {
                    setViewMode(false);
                    setLoading(false);
                  }, 200);
                }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Loading...
                  </>
                ) : (
                  "Edit"
                )}
              </button>
            </div>
          )}
        </Modal>
        <Modal
          visible={showCommentsModal}
          size="lg"
          onClose={() => {
            setShowCommentsModal(false);
            setDiscussion([]);
          }}
          headerText="Page Discussions"
          centered
        >
          {discussion.length > 0 ? (
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              <table className="table table-bordered table-hover align-middle">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "5%" }}>S.No</th>
                    <th style={{ width: "20%" }}>Title</th>
                    <th style={{ width: "40%" }}>Description</th>
                    <th style={{ width: "20%" }}>Created At</th>
                    <th style={{ width: "15%" }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {discussion.map((item, index) => {
                    const dateOnly = new Date(item.create_timestamp)
                      .toLocaleDateString("en-GB");
                    return (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.title}</td>
                        <td>{item.description}</td>
                        <td>{dateOnly}</td>
                        <td>
                          <select
                            value={item.status}
                            onChange={(e) => handleStatusChange(item.id, e.target.value)}
                            className="form-select"
                          >
                            <option value="New">New</option>
                            <option value="Approved">Approved</option>
                          </select>

                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-center text-muted">No comments found.</p>
          )}
        </Modal>


        <CollapseCard title="Pages List">
          <PagesList
            pages={pages}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onView={handleView}
            handleComments={handleComments}
            deletingId={deletingId}
          />
        </CollapseCard>
      </PageContainer>
    </Main >
  );
};

export default Pages;
